import React, { FunctionComponent, useMemo } from 'react';
import * as Styled from './styled';
import Icon from 'ui/atoms/icon';
import Spacer from 'ui/atoms/spacer';
import { convertFileSize } from 'helper/convert-file-size';
import Translate from '../../translate';
import { TruncatedTooltip } from '../../truncated-tooltip';

export interface FileToUpload {
  file: File | null;
  documentType?: string;
}

interface MultipleFileUploadDocumentContainerProps {
  uploadedFiles?: FileToUpload[];
  onRemoveAllDocuments?: () => void;
}

export const MultipleFileUploadDocumentContainer: FunctionComponent<MultipleFileUploadDocumentContainerProps> = ({
  uploadedFiles,
  onRemoveAllDocuments,
}) => {
  const { totalFileSize, fileCount } = useMemo(() => {
    if (!uploadedFiles?.length) return { totalFileSize: 0, fileCount: 0 };

    const size = uploadedFiles.reduce((total, item) => total + (item.file?.size || 0), 0);
    return {
      totalFileSize: size,
      fileCount: uploadedFiles.length,
    };
  }, [uploadedFiles]);

  return (
    <Styled.DocumentContainer>
      <Styled.DocumentContent>
        <Icon size="large" name="document" color="primary" />
        <Spacer x={4} />
        <Styled.DocumentTextContainer>
          <Styled.DocumentNameRemove>
            <TruncatedTooltip>
              <Translate name="uploadPdf.documentsCount" args={[fileCount]} as="div" />
              <Styled.SideTextContent>{convertFileSize(totalFileSize)}</Styled.SideTextContent>
            </TruncatedTooltip>
            <Spacer x={4} />
            <Icon name="close-thin" onClick={onRemoveAllDocuments} />
          </Styled.DocumentNameRemove>
        </Styled.DocumentTextContainer>
      </Styled.DocumentContent>
    </Styled.DocumentContainer>
  );
};

export default MultipleFileUploadDocumentContainer;
